import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Find and close the parent slideover
    // The slideover controller stores instances by ID, so we need to trigger close
    const slideoverElement = document.getElementById('hypothesis-detail')
    if (slideoverElement) {
      // Find the slideover controller and trigger close
      // Create a synthetic click event on the close button
      const closeButton = slideoverElement.querySelector('[data-action*="slideover#close"]')
      if (closeButton) {
        closeButton.click()
      }
    }
  }
}
